import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import StartReview from "./edit";
import { FaChartGantt } from "react-icons/fa6";
import PerformanceReviews from "./index";

const performanceReviewRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Performance Reviews",
		basePath: "performance-reviews",
		mainComponent: <PerformanceReviews/>,
	    layout: "/console",
		// viewComponent: <ViewTrainingModule />,
	    // createComponent: <EditTrainingModule />,
	    editComponent: <StartReview />,	   
	    icon: <FaChartGantt className="icon-item" />,
	    subTitle:"Performance Review",
		level:5,
		moduleId: 0,
	})
]

export default performanceReviewRoutes;